import { RootState } from '../../store';

export const getStatusSelector = (state: RootState) => state?.categoryReducer?.status;
